module.exports = __webpack_public_path__ + "static/img/nps-turnover.4939c1c9.png";